import React , {useState } from 'react' ;
import DataCard from './DataCard';
import Aside from './Aside' ; 
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {reqReviews} from './api'
const record = [
    /* {
    name : "기영석" ,
    avg : "3.5" ,
    mealcount : '112',
    reviewcount : '41',
    gender : '남자',
    age : '32',
    chips : '디자이너 / 든든한한끼 / 간편한한끼',
    reviews : [
        {date:'09.01',
        supplier:'더담쟁이',
        menu:'제육볶음',
        subavg:'3.5',
        text:'양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'08.01',
        supplier:'더담쟁이222',
        menu:'제육볶음222',
        subavg:'4.5',
        text:'2222양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'07.01',
        supplier:'더담쟁이3',
        menu:'제육볶음333',
        subavg:'3.5',
        text:'333양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',}
]
},
{
    name : "나수진" ,
    avg : "4.5" ,
    mealcount : '222',
    reviewcount : '33',
    gender : '여자',
    age : '22',
    chips : '개발자 / 다이어트 / 메롱',
    reviews : [
        {date:'09.01',
        supplier:'더담쟁이444',
        menu:'제육볶음',
        subavg:'3.5',
        text:'양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'08.01',
        supplier:'더담쟁이555',
        menu:'제육볶음222',
        subavg:'4.5',
        text:'2222양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'07.01',
        supplier:'더담쟁이6666',
        menu:'제육볶음333',
        subavg:'3.5',
        text:'333양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',}
]
},
{
    name : "박정재" ,
    avg : "1.7" ,
    mealcount : '66',
    reviewcount : '22',
    gender : '남자',
    age : '66',
    chips : '기획자 / 일식 / 우동',
    reviews : [
        {date:'09.01',
        supplier:'더담쟁이6666',
        menu:'제육볶음',
        subavg:'3.5',
        text:'양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'08.01',
        supplier:'더담쟁이77',
        menu:'제육볶음222',
        subavg:'4.5',
        text:'2222양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',} ,
        {date:'07.01',
        supplier:'더담쟁이9999',
        menu:'제육볶음333',
        subavg:'3.5',
        text:'333양이 부족해서 별점 3.5 드립니다.',
        criteria1:'38',
        criteria2:'23',
        criteria3:'44',
        criteria4:'33',
        criteria5:'8',
        criteria6:'12',}
]
    } */
];

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
      },
      paper: {
        height : '100%',
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      pannel: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      filter : {
        height : '60px',
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }
  }));

const ReviewDataCustomer = ({...props}) => {
    
    const classes = useStyles();
    const [ confirmrecord, setConfirmRecord ] = useState(record); // 컴퍼넌트 전달 데이터
    
    const [customerId, setCustomerId] = useState('A'); 
    const [userCount, setUserCount] = useState('0');
    const [reviewCount, setReviewCount] = useState('0');
    const [mealCount, setMealCount] = useState('0');
    const [kpiCount, setKpiCount] = useState('0');

    
    // Aside 컴퍼넌트 select 선택
    async function parentFunction(customerId , from, to) {
        
        // 1. API 호출 ( customerId , from , to)
        const { data }  = await reqReviews(customerId , from , to) ;
        
        // 2. setUserCount / setReviewCount / setMealCount / setKpiCount
        setUserCount(data.customerInfo.userCount);
        setReviewCount((data.customerInfo.totalReview) ?data.customerInfo.totalReview : 0 );
        setMealCount((data.customerInfo.totalMeal) ?data.customerInfo.totalMeal : 0 );
        setKpiCount((data.customerInfo.avgMeal) ?data.customerInfo.avgMeal : 0 );
        
        // 3. DataCard render
        setConfirmRecord(data.review);
        
    } ;


    return (
    
<div className={classes.root}>
    <Paper className={classes.pannel}>
        <Aside parentFunction={parentFunction} 
            userCount ={userCount}
            reviewCount ={reviewCount}
            mealCount ={mealCount}
            kpiCount= {kpiCount}
        />
    </Paper>

    <Paper className={classes.paper}>
        {confirmrecord.map((element) => (
        <DataCard record={element} />
        ))}
    </Paper>   
</div>

    );
}
export default ReviewDataCustomer;